import { round } from "lodash";

const getTaxAmount = (subtotal: number, percentage: number) => {
  const taxAmount = subtotal * (percentage / 100);
  return round(taxAmount, 2);
};
export default getTaxAmount;
